import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const floatingBadgeShadow =
  "shadow-[0_14px_32px_-6px_rgba(15,23,42,0.35)] ring-1 ring-black/[0.06]";

export function FloatingFeatureBadge({
  icon,
  title,
  subtitle,
  borderClassName = "border-white/70",
  floatClassName = "animate-cta-float",
  className,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  borderClassName?: string;
  floatClassName?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "shrink-0 rounded-xl border bg-card px-2.5 py-2",
        floatingBadgeShadow,
        borderClassName,
        floatClassName,
        className,
      )}
    >
      <div className="flex items-center gap-1.5">
        {icon}
        <span className="text-[10px] font-bold leading-tight text-foreground">{title}</span>
      </div>
      {subtitle ? (
        <p className="mt-0.5 max-w-[120px] text-[8px] leading-snug text-muted-foreground">{subtitle}</p>
      ) : null}
    </div>
  );
}
